import axios from "axios";

function getData(data) {
    return axios.post('api/asociado-contrato/dataAsociadoContrato', data);
}

function guardarData(data) {
    return axios.post('api/asociado-contrato/guardarAsociadoContrato', data);
}

function borrarAsociadoContrato(data) {
    return axios.post('api/asociado-contrato/borrarAsociadoContrato', data).then(r => r.data).catch(r => r);
}


export {
    getData,
    guardarData,
    borrarAsociadoContrato
}
